module.exports = __webpack_public_path__ + "img/soumya.3130b652.png";